import api from './api';

/**
 * Serviço de temas — metadata (id/displayName/order) vinda da tabela `theme` (D10, onda 3).
 * Cor/ícone/prosa de cada tema vêm à parte, via templateLoader (fetch no Static).
 */
const themesService = {
  /**
   * Lista os temas ativos — usada pelo seletor de tema e pela grade do Welcome.
   * @returns {Promise<Array<{id: string, displayName: string, order: number}>>}
   */
  async getActiveThemes() {
    const response = await api.get('/themes');
    return response.data;
  },
};

export default themesService;
